// Angular modules
import { HttpClient }       from '@angular/common/http';
import { HttpHeaders }      from '@angular/common/http';
import { Injectable }       from '@angular/core';

// External modules
import { CartItem }         from './cart.provider';
import { Cart }             from './cart.provider';
import { TranslateService } from '@ngx-translate/core';

// Internal modules
import { environment }      from '../../../environments/environment';

// Helpers
import { StorageHelper }    from '../helpers/storage.helper';


@Injectable()
export class CartService
{
  constructor(
    private http     : HttpClient,
    private translate: TranslateService
  )
  {}

  public isInCart(cartItem : CartItem) : boolean
  {
    const cart = this.getCart();
    return cart.items.some(itm => itm.group === cartItem.group && itm.item.getBusinessCode() === cartItem.item.getBusinessCode())
  }

  public addItem(cartItem: CartItem) : void
  {
    const isInCart = this.isInCart(cartItem);
    if (isInCart)
      return;

    const cart = this.getCart();
    cartItem.timestamp = Date.now();
    cart.items.push(cartItem);
    this.saveCart(cart)
  }

  public removeItem(cartItem : CartItem) : void
  {
    const cart = this.getCart()
    cart.items = cart.items.filter(itm => !((itm.group === cartItem.group) && (itm.item.getBusinessCode() === cartItem.item.getBusinessCode())));
    this.saveCart(cart)
  }

  public getCart(): Cart
  {
    return StorageHelper.getCart();
  }

  public async sendEmail(group : string) : Promise<string>
  {
    const user = StorageHelper.getUser();
    const cart = this.getCart()
    let headers    = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept' : 'application/json', 'apiKey' : environment.API_KEY });
    let options    = { headers: headers, withCredentials: true };
    let body = {
      email : user.email,
      subject : this.translate.instant("MAPAPP_CART_SUBJECT"),
      mail  : cart.mailBody(this.translate, group)
    };
    await this.http.post(
      environment.API_ENDPOINT + '/sendMail',
      body,
      options
    ).toPromise();

    return user.email;
  }

  private saveCart(cart : Cart) : void
  {
    StorageHelper.setCart(cart);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/cart-service.ts